module.exports = __webpack_public_path__ + "img/swipe4-icon-active.f637b3ef.png";